import './Overlay-40e80d0e.css';

var classes = {"Overlay":"prc-Overlay-Overlay-dVyJl"};

export { classes as default };
